import { Box } from '@mui/material';
import HeaderSearch from './Search';
import HeaderNotification from './Notifcation';

function HeaderButtons() {
  return (
    <Box sx={{ mr: 1 }}>
      <HeaderSearch />
      <HeaderNotification />

      <Box sx={{ mx: 0.5 }} component="span"></Box>
    </Box>
  );
}

export default HeaderButtons;
